export default __webpack_public_path__ + "static/media/Bookmark.531fdcc8.svg";